<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="clueCar/findClueCarRecordList.action"
                    ref="intranetClueCarRecordTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="关键词搜索" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.intranetClueCarRecordTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="id"
            prop="id">
        </el-table-column>
        <el-table-column
            label="收车状态">
          <template scope="scope">
            <p v-bind:style="{color:clueStatusColor(scope.row.status)}">{{scope.row.status |
              statusFilter}} </p>
          </template>
        </el-table-column>
        <el-table-column
            label="收车人姓名"
           >
          <template scope="scope">
            {{scope.row.name}}-{{scope.row.phone}}
          </template>
        </el-table-column>
        <el-table-column
            label="收车报价"
            prop="quotePrice">
        </el-table-column>
        <el-table-column
            label="收车备注"
            prop="remark">
        </el-table-column>
        <el-table-column
            label="创建时间"
           >
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template scope="scope">
            <el-button type="text" @click.native.prevent="$router.push({path:'/home/intranetClueCarRecordItem', query: { id: scope.row.id }})"  size="mini">
              修改
            </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetClueCarRecord',
  data: function () {
    return {
      queryParams: {
        id: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.id = query.id
  },
  methods: {
    clueStatusColor: function (clueStatus) {
      let color = ''
      switch (clueStatus) {
        case 1:
          color = 'red'
          break
        case 2:
          color = '#FF8C00'
          break
        case 3:
          color = ''
          break
        case 4:
          color = 'green'
          break
      }
      return color
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetClueCarRecordTable.search()
    }
  },
  filters: {

    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '正在收车'
          break
        case 2:
          str = '排队收车'
          break
        case 3:
          str = '放弃收车'
          break
        case 4:
          str = '成功收车'
          break
        case 5:
          str = '锁定看车'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
